
import TaiBaseWidget from "../base.widget.js";
import flatpickr from "flatpickr";

import dateTemplate from './Date.template.html';
import useReactiveZone from "reactive-zone";
import { DateUtil } from "../../utils/index.js";

const FORMAT_DATE = 'dd/mm/yyyy'
class DateWidget extends TaiBaseWidget {

    zone = useReactiveZone(this);

    refInput = this.zone.useElementRef('ref.input');

    props = this.zone.injectPropToZone({
        selectedDate: this.fieldModel.userResponse ? new Date(this.fieldModel.userResponse) : new Date(),
        displayConvertedValue: ''
    })

    template() {
        return dateTemplate;
    }

    getValue() {
        return this.props.selectedDate.getTime();
    }

    setValue(value) {
        if (this.refInput.element) {
            this.refInput.element.value = DateUtil.FormatDate(value, 'YYYY-MM-DD')
        }
    }

    getDisplayText() {

    }

    onRendered() {
        super.onRendered();
        flatpickr(this.refInput.element, {
            defaultDate: new Date(),
            dateFormat: "d/m/Y",
            allowInvalidPreload: true,
            onChange: (selectedDates, dateStr, instance) => {
                this.props.selectedDate = selectedDates[0];
            },
        });
    }
}

export default DateWidget;